module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/148e4f4cfc7a1a253eb52c50bbb635a0.svg";